import { useState } from "react";

const useFoundStudentList = () => {
	const [foundStudentList, setFoundStudentList] = useState([]);
	function clearFoundStudentList() {
		setFoundStudentList([]);
	}
	const fillFoundStudentList = (studentReservations, studentName) => {
		const newFoundStudentList = studentReservations
			.filter(({ name }) => {
				if (!name)
					return false;
				return name
					.toUpperCase()
					.includes(studentName.toUpperCase().trim());
			})
			.map(({ id, name: text }) => ({
				id,
				text,
			}));
		setFoundStudentList(newFoundStudentList);
	};
	return {
		value: foundStudentList,
		clear: clearFoundStudentList,
		fill: fillFoundStudentList,
	};
};

export default useFoundStudentList;
